function afSharePage(shareButtonMobile,title) {
    //Sharing button - start
    //Sharing jobs on mobile
    const shareData = title !== null ? {text: title.dataset.title,url: window.location.href} : {url: window.location.href};
    if (!navigator.canShare(shareData)) {
        shareButtonMobile.style.display = "none";
    }
    //Give a share button functionality
    function afShareJobPageForMobile() {
        navigator.share(shareData)
    }
    shareButtonMobile.addEventListener("click",afShareJobPageForMobile);
    //Sharing button - end
}

export default afSharePage;
